import store from '@/store/index';
import { isEmptyVal } from '@/utils';

/**
 * LOOKUP router
 * generate lookup parameters for Net new customer
 * [Only needs to be added for users who are not logged in]
 * @returns {{}|{accountId: string, email: string}}
 */
export const getLookupRouterParams = () => {
  const accountId = store.getters.lookupInfo?.accountId;
  const email = store.getters.lookupInfo?.email;
  const loggedIn = window.$context?.is?.loggedIn;

  if (isEmptyVal(accountId)) {
    return {};
  } else {
    return loggedIn ? {} : { accountId, email };
  }
};
